import { useState, useEffect, useCallback } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { usePcBundle } from "../index";
import modules from "modules";

const { actions: BuildsGalleryActions } = modules.buildsGallery;

const useRenderData = (brand, requestParams) => {
  const dispatch = useDispatch();
  const {
    isLoading: isBundleLoading,
    bundleList,
    getPcBundleList,
  } = usePcBundle();

  const [isBuildsGalleryLoading, setIsBuildsGalleryLoading] = useState(true);
  const [buildsGalleryItems, setBuildsGalleryItems] = useState([]);
  const [isPcBuildsRendering, setIsPcBuildsRendering] = useState(true);

  // Fetch PC Bundle Data
  useEffect(() => {
    getPcBundleList(`Powered by ${brand}`);
  }, [getPcBundleList, brand]);

  const getBuildsGalleryItem = useCallback(
    async (requestBodyArg = requestParams) => {
      setIsBuildsGalleryLoading(true);
      try {
        const response = unwrapResult(
          await dispatch<any>(
            BuildsGalleryActions.getBuildsGalleryPageThunk(requestBodyArg)
          )
        );

        if (response?.success) {
          setBuildsGalleryItems(response?.originalData?.data);
        }
      } catch (error) {
        console.error("Error fetching builds gallery:", error);
      } finally {
        setIsBuildsGalleryLoading(false);
      }
    },
    [dispatch, requestParams]
  );

  useEffect(() => {
    getBuildsGalleryItem();
  }, [getBuildsGalleryItem]);

  useEffect(() => {
    if (!isBundleLoading && bundleList?.length > 0) {
      setIsPcBuildsRendering(false);
    }
  }, [isBundleLoading, bundleList]);

  useEffect(() => {
    if (!isBuildsGalleryLoading && buildsGalleryItems.length > 0) {
      setIsPcBuildsRendering(false);
    }
  }, [isBuildsGalleryLoading, buildsGalleryItems]);

  return {
    isBundleLoading,
    bundleList,
    isBuildsGalleryLoading,
    buildsGalleryItems,
    isPcBuildsRendering,
  };
};

export default useRenderData;
